/** Max characters shown in the My leave requests Comments column before ellipsis. */
export const LEAVE_REQUEST_COMMENT_DISPLAY_MAX_LEN = 48;

/**
 * Formats leave request comments for table display. Returns an em dash when empty.
 */
export function formatLeaveRequestComments(
  comments?: string | null,
  maxLen = LEAVE_REQUEST_COMMENT_DISPLAY_MAX_LEN
): string {
  if (!comments?.trim()) return '—';
  const trimmed = comments.trim();
  if (trimmed.length <= maxLen) return trimmed;
  return `${trimmed.slice(0, maxLen)}…`;
}
